<div class="d-md-flex align-items-center bg-white p-2">
  <div class="ml-auto mt-3 mt-md-0" >
    <button type="button" (click)="edit()" class="btn btn-cyan rounded-pill p-2" ><i
      class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'Smtp.add' | translate}}</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
    <tr>
      <th scope="col">{{'Smtp.user' | translate}}</th>
      <th scope="col">{{'Smtp.Actions' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of List ">
      <td class="align-middle">
        {{item.user}}
      </td>
      <td class="align-middle">
        <a href="javascript:void(0)" (click)="edit(item)" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-pencil-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
